import Toast from '@ingka/toast';
import { useNestedTranslation } from 'hooks/useNestedTranslation';
import React, { useState } from 'react';
import { isProd } from 'utils/environments';

const FeedbackForm = () => {
    const [isOpen, setIsOpen] = useState(true);
    const t = useNestedTranslation('feedback');
    const feedbackUrl = process.env.VITE_APP_URLS_feedback_url;

    // Hide form after April 30, 2026 (2 Weeks visibility)
    const deadline = new Date('2026-04-30');
    const today = new Date();
    if (today > deadline) {
        return null;
    }

    return (
        <div data-testid="feedback-form">
            {isProd && (
                <Toast
                    data-testid="survey-form-toast"
                    text={<strong>{t('description')}</strong>}
                    isOpen={isOpen}
                    actionButtonText={t('buttonText')} // optional
                    actionClick={() => {
                        window.open(feedbackUrl, '_blank');
                        setIsOpen(false);
                    }}
                    onCloseRequest={() => setIsOpen(false)}
                    ariaLabelCloseBtn="Dismiss notification"
                    style={{ zIndex: 2147483647 }}
                />
            )}
        </div>
    );
};

export default FeedbackForm;
